import React, { useState } from 'react';
import ReusableTabs from '../../pages/ReusableTabs';
import VehiclesAwating from './InternalTabs/VehiclesAwating';
import Analysis from './InternalTabs/Analysis';
import Received from './InternalTabs/Received';
import FlaggedModulesReview from './InternalTabs/FlaggedModules';
import FlaggedPalletAnalysis from './InternalTabs/FlaggedPalletAnalysis';

const PDI_TAB_KEY = "selectedPdiTab"; 

const PdiTabsComponent = () => {
  const tabs = [
    { label: 'Vehicles Awaiting Unloading', component: <VehiclesAwating /> },
    { label: 'Flagged Pallet Analysis', component: <FlaggedPalletAnalysis /> },
    { label: 'Flagged Modules Review', component: <FlaggedModulesReview /> },
    { label: 'Analysis', component: <Analysis /> },
  ];

  // ✅ Read persisted tab index on mount, fallback to 0
  const [selectedTab, setSelectedTab] = useState(() => {
    const stored = sessionStorage.getItem(PDI_TAB_KEY);
    const index = parseInt(stored, 10);
    return !isNaN(index) && index < tabs.length ? index : 0;
  });

  const handleTabChange = (index) => {
    setSelectedTab(index);
    sessionStorage.setItem(PDI_TAB_KEY, index); 
  };

  return (
    <ReusableTabs
      tabs={tabs}
      activeTab={selectedTab}        
      onTabChange={handleTabChange}
      panelStyles={{ padding: '16px' }}
    />
  );
};

export default PdiTabsComponent;